module.exports = __webpack_public_path__ + "img/livecasino.2fcb331e.png";